import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const LocationWavesNorthFill48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M22.5127 23.5674C23.0487 22.273 24.9497 22.2673 25.4844 23.5684L31.1446 37.0313L29.2979 37.792L23.9922 34.086L18.6973 37.792L16.8506 37.0303L22.5127 23.5674ZM13.6279 13.6055C19.3558 7.9035 28.6425 7.90375 34.3692 13.6055C39.7811 18.9916 40.0752 27.5352 35.2647 33.2706L33.6563 31.669C37.576 26.8258 37.2812 19.6968 32.7666 15.2002C27.9306 10.3865 20.0651 10.3864 15.2305 15.2002C10.7147 19.6969 10.4219 26.8279 14.3418 31.671L12.7334 33.2715C7.92572 27.5349 8.21742 18.9916 13.6279 13.6055ZM17.4014 17.3604C21.0387 13.7373 26.9616 13.7377 30.6016 17.3594C33.9187 20.6639 34.202 25.8507 31.4688 29.4883L29.8457 27.8741C31.7084 25.1378 31.431 21.379 28.999 18.9561C26.243 16.2133 21.7586 16.2132 19.0039 18.9561C16.5721 21.3777 16.2946 25.1379 18.1572 27.8741L16.5352 29.4893C13.8006 25.8517 14.0816 20.6649 17.4014 17.3604Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
